/**
 * Config bắt đầu từ đây!
 * Quy định route với: Private, public, separate route ...
 */
import TaxFill from 'layout/taxFill';

import Vehicle from 'entities/vehicle';
import Seating from 'entities/seating';
import Journey from 'entities/journey';
import Orders from 'entities/orders';
import Ticket_managers from 'entities/ticket-managers';
import Dashboard from 'entities/dashboard/index';
import EditMyProfile from 'entities/user-profile/edit-my-profile';
import Profile from 'entities/user-profile/profile';
import ActiveAccount from '../layout/active.account';
import Login from '../layout/login';
import QuickLogin from '../layout/quick.login';
import RecoverPassword from '../layout/recover-password';

import Customer from 'entities/customer';
import IncomingWebhook from 'entities/incoming_webhook';
import OutgoingWebhook from 'entities/outgoing_webhook';
import Analytics from '../entities/analytics';
import Contactform from '../entities/contactform';
import Media from '../entities/media';
import MediaSetting from '../entities/media_setting';
import Notification from '../entities/notification';
import Posts from '../entities/posts';
import Pages from '../entities/pages';
import Settings from '../entities/settings/index';
import Pbx from '../entities/pbx';
import Users from '../entities/users';
import ViewPage from '../entities/viewpage';

import AccountSetting from 'entities/account_setting';
import BackUp from 'entities/backup';
import Embed from 'entities/embed';
import KeyMapIndex from 'entities/keymap';
import Security from 'entities/security';
import ServerInfo from 'entities/server_info';
import Phonelog from 'entities/phonelog';
import AddressSuggestion from 'entities/address_suggestion';
import Promotion from 'entities/promotion';
import Charge_station from 'entities/charge_station';
import Vehicle_management from 'entities/vehicle_management';
import ChargeTransaction from 'entities/charge_transaction';
import Transactions from 'entities/transactions';
import TransactionsCallback from 'entities/transactions_callback';
import VehicleTracking from 'entities/vehicle_tracking';
import TripManifest from 'entities/trip_manifest';
import DriverSettlement from 'entities/driver_settlement';
import Invoices from 'entities/invoices';
import Dispatch from 'entities/dispatch';

/**
 * Private, w/ <AppFrame />
 * Only authorization can access this route
 */

export const private_route = [
  {
    path: '/',
    Entity: Dashboard,
  },
  {
    path: '/dispatch',
    Entity: Dispatch,
  },
  {
    path: '/invoices',
    Entity: Invoices,
  },
  {
    path: '/invoices/:slug',
    Entity: Invoices,
  },
  {
    path: '/transactions',
    Entity: Transactions,
  },
  {
    path: '/driver_settlement',
    Entity: DriverSettlement,
  },
  {
    path: '/driver_settlement/:id',
    Entity: DriverSettlement,
  },
  {
    path: '/trip_manifest',
    Entity: TripManifest,
  },
  {
    path: '/transactions_callback',
    Entity: TransactionsCallback,
  },
  {
    path: '/charge_transaction',
    Entity: ChargeTransaction,
  },
  {
    path: '/charge_transaction/:slug',
    Entity: ChargeTransaction,
  },
  {
    path: '/charge_transaction/:slug/:charge_transaction_id',
    Entity: ChargeTransaction,
  },
  {
    path: '/charge_station/:slug',
    Entity: Charge_station,
  },
  {
    path: '/charge_station/:slug/:charge_station_id',
    Entity: Charge_station,
  },
  {
    path: '/charge_station',
    Entity: Charge_station,
  },

  {
    path: '/vehicle_management/:slug',
    Entity: Vehicle_management,
  },
  {
    path: '/vehicle_management/:slug/:vehicle_id',
    Entity: Vehicle_management,
  },

  {
    path: '/vehicle_management',
    Entity: Vehicle_management,
  },

  {
    path: '/vehicle_tracking/:slug',
    Entity: VehicleTracking,
  },
  {
    path: '/vehicle_tracking/:slug/:vehicle_id',
    Entity: VehicleTracking,
  },

  {
    path: '/vehicle_tracking',
    Entity: VehicleTracking,
  },
  {
    path: '/address_suggestion',
    Entity: AddressSuggestion,
  },
  {
    path: '/promotion',
    Entity: Promotion,
  },
  {
    path: '/phonelog',
    Entity: Phonelog,
  },

  {
    path: '/keymap',
    Entity: KeyMapIndex,
  },

  {
    path: '/analytics/:slug/:sub_slug',
    Entity: Analytics,
  },
  {
    path: '/analytics/:slug',
    Entity: Analytics,
  },

  {
    path: '/analytics',
    Entity: Analytics,
  },

  {
    path: '/notification',
    Entity: Notification,
  },
  {
    path: '/notification/:slug/:notification_slug',
    Entity: Notification,
  },
  {
    path: '/notification/:slug',
    Entity: Notification,
  },

  {
    path: '/profile',
    Entity: Profile,
  },

  {
    path: '/edit-my-profile',
    Entity: EditMyProfile,
  },

  {
    path: '/settings',
    Entity: Settings,
  },
  {
    path: '/account_setting',
    Entity: AccountSetting,
  },
  {
    path: '/account_setting/:slug',
    Entity: AccountSetting,
  },
  {
    path: '/post/:post_slug',
    Entity: ViewPage,
  },

  {
    path: '/posts/:slug/:pages_slug',
    Entity: Posts,
  },
  {
    path: '/posts/:slug',
    Entity: Posts,
  },

  {
    path: '/posts',
    Entity: Posts,
  },

  {
    path: '/pages/edit/:pages_slug',
    Entity: Pages,
  },
  {
    path: '/pages/new',
    Entity: Pages,
  },
  {
    path: '/pages/:post_slug',
    Entity: ViewPage,
  },
  {
    path: '/pages',
    Entity: Pages,
  },

  {
    path: '/media',
    Entity: Media,
  },
  {
    path: '/media/:slug/:media_slug',
    Entity: Media,
  },
  {
    path: '/media/:slug',
    Entity: Media,
  },
  {
    path: '/media_setting',
    Entity: MediaSetting,
  },
  {
    path: '/users/:slug/:users_slug',
    Entity: Users,
  },
  {
    path: '/users/:slug',
    Entity: Users,
  },
  {
    path: '/users',
    Entity: Users,
  },

  {
    path: '/vehicle',
    Entity: Vehicle,
  },
  {
    path: '/vehicle/:vehicle_id',
    Entity: Vehicle,
  },
  {
    path: '/vehicle/:vehicle_id/:mode',
    Entity: Vehicle,
  },
  {
    path: '/vehicle/:vehicle_id/:mode/:vehicle_log_id',
    Entity: Vehicle,
  },

  {
    path: '/seating',
    Entity: Seating,
  },
  {
    path: '/journey/:slug/:journey_id',
    Entity: Journey,
  },
  {
    path: '/journey/:slug',
    Entity: Journey,
  },
  {
    path: '/journey',
    Entity: Journey,
  },

  {
    path: '/orders/:slug/:order_id',
    Entity: Orders,
  },

  {
    path: '/orders/:slug',
    Entity: Orders,
  },
  {
    path: '/orders',
    Entity: Orders,
  },
  {
    path: '/ticket_managers',
    Entity: Ticket_managers,
  },

  {
    path: '/incoming_webhook',
    Entity: IncomingWebhook,
  },
  {
    path: '/incoming_webhook/:slug/:incoming_webhook_slug',
    Entity: IncomingWebhook,
  },
  {
    path: '/incoming_webhook/:slug',
    Entity: IncomingWebhook,
  },

  {
    path: '/outgoing_webhook',
    Entity: OutgoingWebhook,
  },
  {
    path: '/outgoing_webhook/:slug/:outgoing_webhook_slug',
    Entity: OutgoingWebhook,
  },
  {
    path: '/outgoing_webhook/:slug',
    Entity: OutgoingWebhook,
  },

  {
    path: '/customer',
    Entity: Customer,
  },
  {
    path: '/customer/:slug/:customer_id',
    Entity: Customer,
  },
  {
    path: '/customer/:slug',
    Entity: Customer,
  },

  {
    path: '/contactform',
    Entity: Contactform,
  },
  {
    path: '/contactform/:slug/:contactform_id',
    Entity: Contactform,
  },
  {
    path: '/contactform/:slug',
    Entity: Contactform,
  },

  {
    path: '/backup',
    Entity: BackUp,
  },

  {
    path: '/embed',
    Entity: Embed,
  },

  {
    path: '/security',
    Entity: Security,
  },

  {
    path: '/server_info',
    Entity: ServerInfo,
  },
  {
    path: '/pbx',
    Entity: Pbx,
  },
];

/**
 * Any one can access this URL
 */
export const public_route = [
  {
    path: '/taxfill',
    Entity: TaxFill,
  },
];

/**
 * Run first and wihout <AppFrame>,
 * It is like login page, register page
 */

export const separate_route = [
  {
    path: '/login',
    Entity: Login,
  },
  {
    path: '/active-account',
    Entity: ActiveAccount,
  },
  {
    path: '/login/sso',
    Entity: Login,
  },
  {
    path: '/quick-login/:token',
    Entity: QuickLogin,
  },
  {
    path: '/recover_password',
    Entity: RecoverPassword,
  },
];
